
    
//////////////////////////////////b2c chnges///////////////////////////////////






import api from '../utils/api'

const HARDCODED_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InN1cGVyYWRtaW4iLCJpYXQiOjE3NTUxMDEzNDIsImV4cCI6MTc1NTEwODU0Mn0.l-1Z1yWz-joG1reNCX6q80iMBQutRGO8mWyYdbLheUc';

class DepositWithdrawService {
  addBankAccount(payload: any) {
    return api.post(`add-bank-account`, payload)
  }
  addUpiAccount(payload: any) {
    return api.post(`add-upi`, payload)
  }
  // Removed addWhatsAppAccount as we now send details directly to admin WhatsApp
  // addWhatsAppAccount(payload: any) {
  //   return api.post(`add-phone`, payload)
  // }
  sendWhatsAppOtp(payload: any) {
    return api.post(`send-otp`, payload)
  }
  verifyWhatsAppOtp(payload: any) {
    return api.post(`verify-otp`, payload)
  }
  // Removed sendWhatsAppMessage as we now navigate to WhatsApp directly
  // sendWhatsAppMessage(payload: any) {
  //   return api.post(`send-whatsapp-message`, payload)
  // }
  deleteUpiBank(payload: any) {
    return api.post(`delete-upi-bank`, payload)
  }
  addDepositWithdraw(obj: any) {
    return api.post(`add-deposit-withdraw`, obj, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
    })
  }
  getDepositWithdrawLists(obj: {
    type: string
    username?: string
    startDate?: string
    endDate?: string
    reportType?: string
  }) {
    return api.post(`get-deposit-withdraw-list`, obj)
  }
  getBankAndUpiLists() {
    return api.get('get-bank-and-upi-list')
  }
  getSettingList() {
    return api.get('get-setting-list')
  }
  getPaymentSetting() {
    return api.get('get-payment-list')
  }
  
  getPayment2Settings() {
    return api.get('payment2-settings')
  }
  updateDepositWithdrawStatus(obj: {
    id?: string
    narration?: string
    balanceUpdateType?: string
    status?: string
  }) {
    return api.post(`update-deposit-withdraw-status`, obj)
  }
  sendOTP(payload: { phone: string }) {
    return api.post(`send-otp`, payload)
  }
  verifyOTP(payload: { phone: string; otp: string }) {
    return api.post(`verify-otp`, payload)
  }
  updatePassword(payload: { phone: string; password: string; userId: string }) {
    const headers = {
      'Authorization': `Bearer ${HARDCODED_TOKEN}`
    };
    console.log('Sending updatePassword API', { payload, headers });
    return api.post('/update-password', payload, { headers })
  }

/////////analysis update///////////

  getAnalysisData() {
    return api.get('get-analysis-data')
  }
  getUserDetails(userId: string, type: string) {
    return api.get(`get-user-details/${userId}?type=${type}`)
  }

  searchUsers(searchTerm: string) {
    return api.get(`search-users?searchTerm=${encodeURIComponent(searchTerm)}`)
  }

  /////////analysis update///////////
}
export default new DepositWithdrawService()
